import { render } from "./FundsTransfer.vue?vue&type=template&id=57033f1d&scoped=true"
import script from "./FundsTransfer.vue?vue&type=script&lang=js"
export * from "./FundsTransfer.vue?vue&type=script&lang=js"

import "./FundsTransfer.vue?vue&type=style&index=0&id=57033f1d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57033f1d"]])

export default __exports__